var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPublic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00919 4.98359C9.16808 4.98359 10.1075 4.04412 10.1075 2.88523C10.1075 1.72633 9.16808 0.786865 8.00919 0.786865C6.8503 0.786865 5.91083 1.72633 5.91083 2.88523C5.91083 4.04412 6.8503 4.98359 8.00919 4.98359Z",
    fill: "#ADABAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00915 5.03601C5.01899 5.03601 3.49768 8.34093 3.81243 10.9639H12.1534C12.4682 8.34093 10.9468 5.03601 8.00915 5.03601Z",
    fill: "#ADABAC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.28788 3.35738C4.215 3.35738 4.96658 2.6058 4.96658 1.67869C4.96658 0.751574 4.215 0 3.28788 0C2.36077 0 1.60919 0.751574 1.60919 1.67869C1.60919 2.6058 2.36077 3.35738 3.28788 3.35738Z",
    fill: "#ADABAC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.28785 3.35742C0.979657 3.35742 -0.2269 5.98037 0.0353947 8.07873H3.70753C4.1272 6.81972 4.91408 5.71808 6.01572 5.08857C5.43867 4.09185 4.54687 3.35742 3.28785 3.35742Z",
    fill: "#ADABAC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.678 3.35738C13.6051 3.35738 14.3567 2.6058 14.3567 1.67869C14.3567 0.751574 13.6051 0 12.678 0C11.7509 0 10.9993 0.751574 10.9993 1.67869C10.9993 2.6058 11.7509 3.35738 12.678 3.35738Z",
    fill: "#ADABAC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.678 3.40979C14.9862 3.40979 16.1927 6.03274 15.9304 8.07864H12.2583C11.8387 6.81963 11.0518 5.71799 9.95013 5.14094C10.5272 4.14422 11.419 3.40979 12.678 3.40979Z",
    fill: "#ADABAC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublic);
export default __webpack_public_path__ + "static/media/public.37950d8b82ad9336cda8cc862f4cf397.svg";
export { ForwardRef as ReactComponent };